import React from 'react';
import logoImg from '../assets/img/red-logo.png';
import { Link } from 'react-router-dom';
import { IoLogoFacebook } from "react-icons/io5";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";



const Footer = () => {


  return (
    <footer className="footerbg">
        <div className="container px-3">

          {/* Grid */}
          <div className="row pt-4 g-4">

            {/* Column 1 */}
            <div className="col-12 col-sm-6 col-lg-4">
                <div className="pe-5 aboutfooter">
                    <img src={logoImg} alt="Brand Logo" className="mb-3" />

                    <p>
                      At InP, we empower professionals to Express, Explore, and Exchange insight that shapes the industries of tomorrow.
                    </p>

                    <h6 className="mt-5 mb-3">Follow us on</h6>
                    <div className="d-flex gap-4 socalicon">
                      <Link to=""><IoLogoFacebook className="text-white social-icon fb" /></Link>
                      <Link to=""><FaLinkedin className="text-white social-icon linkedin" /></Link>
                      <Link to=""><FaXTwitter className="text-white social-icon twitter" /></Link>
                      <Link to=""><FaInstagram className="text-white social-icon insta" /></Link>
                    </div>
                </div>
            </div>

            {/* Column 2 */}
            <div className="col-12 col-sm-6 col-lg-2">
              <h6 className="fw-bold mb-4 mt-4 sm:mt-0">Quick Links</h6>
              <ul className="list-unstyled">
                <li><Link to="/signup">Sign Up</Link></li>
                <li><Link to="/login">Sign In</Link></li>
                <li><Link to="/create-survey">Create Survey</Link></li>
                {/* <li><Link to="/referral">Referral</Link></li>
                <li><Link to="/blogs">Blogs</Link></li> */}
                {/* <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-and-conditions">Terms And Conditions</Link></li> */}
              </ul>
            </div>

            {/* Column 3 */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="ps-5">
                <h6 className="fw-bold mb-4">About Us</h6>
                <ul className="list-unstyled">
                  <li><Link to="/about">About Company</Link></li>
                  <li><Link to="/contactus">Contact Us</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                  {/* <li><Link to="#">Data Protection & Security</Link></li> */}
                  <li><Link to="/cookie-policy">Cookie Preferences</Link></li>
                </ul>
              </div>
            </div>

            {/* Column 4 */}
            <div className="col-12 col-sm-6 col-lg-3">
              <h6 className="fw-bold mb-4">Contact Info</h6>

              <p className="">
                Pegasus Tower, A-10, 8th Floor, Sector-68, Gautam Buddha Nagar, Noida, Uttar Pradesh, 201301
              </p>

              <div className="mt-5 small">
                <p><span className="text-danger">Phone:</span> <a href="tel:+91 11 40789940">+91 11 40789940</a></p>
                <p><span className="text-danger">Email:</span> <a href="mailto:sales@industryandpeople.com">sales@industryandpeople.com</a></p>
              </div>

              {/* Newsletter */}
              <div className="mt-5">
                <h6 className="mb-4">Our Newsletter</h6>

                <div className="d-flex flex-column flex-sm-row footersubscribe">
                  <input type="email" placeholder="Enter your email" className="newsletterinput" /> 
                  
                  <button className="newsletterbtn"> Subscribe </button>
                </div>
              </div>
            </div>

          </div>

          {/* Back to top */}
          <div className="text-center mt-3">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="back-to-top"
            >
              <i className="fas fa-chevron-up"></i>
            </button>
          </div>

          {/* Bottom */}
          <div className="pt-3 border-top mt-3 copyright">
            <p>&copy; 2026 Industry & People. All Rights Reserved.</p>
          </div>

        </div>
      </footer>
  );
};

export default Footer;
